import styles from "./Section.module.scss";
import { ReactNode } from "react";
import { clsx } from "clsx";

interface SectionProps {
  children: ReactNode;
  title?: ReactNode;
  subtitle?: ReactNode;
  gridClassName?: string;
  headerButton?: ReactNode;
}

export default function Section({
  children,
  title,
  subtitle,
  gridClassName,
  headerButton,
}: SectionProps) {
  return (
    <div>
      {title && (
        <div className={styles.titleArea}>
          <div className={styles.mainTitleRow}>
            <h2 className={clsx(styles.title, "template-h1")}>{title}</h2>
            {headerButton}
          </div>
          {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
        </div>
      )}
      <div className={clsx(styles.childGrid, gridClassName)}>{children}</div>
    </div>
  );
}
